export default __webpack_public_path__ + "static/3-12898fa795cd8af5416e9f7bb40639e7.jpg";